import React, { useState } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Login    from './pages/Login';
import Sessions from './pages/Sessions';
import Player   from './pages/Player';
import Profile  from './pages/Profile';
import Expired  from './pages/Expired';
import BottomNav from './components/BottomNav';
import './App.css';

function Shell() {
  const { user, loading } = useApp();
  const [tab, setTab]             = useState('sessions');
  const [activeSession, setActiveSession] = useState(null);

  if (loading) {
    return (
      <div className="splash">
        <div className="splash-title">Gimnasia<br />Consciente</div>
        <div className="splash-author">por María Rosa Poggi</div>
      </div>
    );
  }

  if (!user) return <Login />;

  if (user.subscriptionStatus === 'expired') return <Expired />;

  if (activeSession) {
    return (
      <Player
        session={activeSession}
        onClose={() => setActiveSession(null)}
      />
    );
  }

  return (
    <div className="app-shell">
      {tab === 'sessions' && (
        <Sessions onSelect={setActiveSession} />
      )}
      {tab === 'profile' && (
        <Profile onBack={() => setTab('sessions')} />
      )}
      <BottomNav current={tab} onChange={setTab} />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}
